import {PencilIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasDescription, pluralize} from './activity-row-helpers'

export function DescriptionRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasDescription(summary)) return null

  const n = summary.descriptionUpdated.count
  const label = `${n} description ${pluralize(n, 'update', 'updates')}`

  return <SidebarActivityRow icon={PencilIcon} label={label} group="description" expectedCount={n} />
}
